import axios from 'axios';
import Seniority from '@/domain/seniority/seniority.entity';
import snackBarService from '@/shared/snackbar/snackbar.service';

export default class SeniorityService {
  static searchAllSeniorities(): Promise<Seniority[]> {
    return axios
      .get('/project-api/seniorities')
      .then((response: any) => Seniority.ofList(response.data))
      .catch((err: any) => snackBarService.errorMessage(err.response.data.messages));
  }
}
